import {
	DescimalRountingPrecision,
	RoundingType,
	WholeNumberRountingPrecision
} from "@/Contracts/Settings";
import NumberScale from "decimal.js";

const RoundingModeMap = {
	[RoundingType.Ceiling]: NumberScale.ROUND_CEIL,
	[RoundingType.Floor]: NumberScale.ROUND_FLOOR,
	[RoundingType.Nearest]: NumberScale.ROUND_HALF_UP,
	[RoundingType.HalfUp]: NumberScale.ROUND_HALF_UP,
	[RoundingType.HalfDown]: NumberScale.ROUND_HALF_DOWN,
	[RoundingType.HalfToEven]: NumberScale.ROUND_HALF_EVEN,
	[RoundingType.HalfAwayFromZero]: NumberScale.ROUND_UP,
	[RoundingType.HalfTowardsZero]: NumberScale.ROUND_DOWN,
	[RoundingType.HalfToOdd]: 0
};

const getHalfToOddValue = (value: number, noOfDigits: number) => {
	const roundedHalfUp = new NumberScale(value)
		.toSD(noOfDigits, RoundingModeMap[RoundingType.HalfUp] as any)
		.toNumber();
	const roundedHalfDown = new NumberScale(value)
		.toSD(noOfDigits, RoundingModeMap[RoundingType.HalfDown] as any)
		.toNumber();
	const roundedHalfEven = new NumberScale(value)
		.toSD(noOfDigits, RoundingModeMap[RoundingType.HalfToEven] as any)
		.toNumber();
	if (roundedHalfUp === roundedHalfDown) {
		return roundedHalfUp;
	} else if (roundedHalfUp === roundedHalfEven) {
		return roundedHalfDown;
	}
	return roundedHalfUp;
};

export default (
	value: string | number,
	precision: DescimalRountingPrecision | WholeNumberRountingPrecision,
	roundingMode: RoundingType
) => {
	const parsedValue = parseFloat(value.toString());
	const precisionOffset = Math.pow(10, precision);
	let newValue = parsedValue * precisionOffset;
	const [wholeNumberDigits] = newValue.toString().split(".");
	const noOfDigits = wholeNumberDigits.length || 1;
	if (roundingMode === RoundingType.HalfToOdd) {
		newValue = getHalfToOddValue(newValue, noOfDigits);
	} else {
		const [newWholeNumberDigits] = new NumberScale(newValue)
			.toSD(noOfDigits, RoundingModeMap[roundingMode] as any)
			.toNumber()
			.toString()
			.split(".");
		newValue = parseInt(newWholeNumberDigits);
	}
	newValue /= precisionOffset;
	return newValue;
};
